import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import schema from './schemas';

import { useGlobal } from '../../../../../contexts/Global/context';
import { useBeneficiarioEventual } from '../../../../../contexts/BeneficiarioEventual/context';

import * as S from './styles';
import { ContainerButton, PageContainer } from '../../../../../styles/styles';

import DatepickerRange from '../../../../../components/Inputs/DatepickerRange';
import FormContainer from '../../../../../components/FormContainer';
import PageLoader from '../../../../../components/PageLoader';
import Accordion from '../../../../../components/Accordion';
import Button from '../../../../../components/Button';
import Alert from '../../../../../components/Alert';
import Modal from '../../../../../components/Modal';
import Icon from '../../../../../components/Icons';

import { cloneObject } from '../../../../../utils';
import { cancelarAgendamento, consultasFulturas } from '../../../../../services';

function ListaConsulta() {
    const history = useHistory();
    const { contrastTheme } = useGlobal();
    const { dataConsultaAtendimento } = useBeneficiarioEventual();
    const [showModal, setShowModal] = useState(false);
    const [showModalDeleteFile, setShowModalDeleteFile] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const [filterValues, setFilterValues] = useState(cloneObject(schema));
    const [rangeLimits, setRangeLimits] = useState({
        min: schema.rangeDate.value[0],
        max: schema.rangeDate.value[1],
    });
    const [dataTable, setDataTable] = useState([]);
    const [dataTableDefault, setDataTableDefault] = useState([]);
    const [selected, setSelected] = useState([]);
    const [sucessDelete, setSucessDelete] = useState(false);
    const modalMessage = 'A sua consulta foi cancelada com sucesso.';
    const [emptyMessage, setEmptyMessage] = useState(
        'Não encontramos esse beneficiário eventual. Você pode fazer uma nova pesquisa.'
    );

    function handleSelect(value) {
        dataTable.every((item) => {
            if (item.idConsulta === value) {
                item.selected = true;

                setSelected(value);
                return false;
            }

            return true;
        });
    }

    async function handleSearch() {
        setPageLoading(true);
        if (dataTableDefault?.length > 0) {
            const data = cloneObject(dataTableDefault);

            if (rangeLimits.min && rangeLimits.max) {
                const dataMax = moment(rangeLimits.max).format('DD/MM/YYYY');
                const dataMin = moment(rangeLimits.min).format('DD/MM/YYYY');

                const filtrarDados = data.filter((element) => element.data >= dataMin && element.data <= dataMax) || [];

                setDataTable(filtrarDados);
                setEmptyMessage('Não encontramos dados com essa data escolhida. Você pode fazer uma nova pesquisa.');
            } else {
                setDataTable(data);
            }
        }
        setPageLoading(false);
    }

    function handleChangeFilter(event) {
        const { id, value, draftFlow } = event;

        const field = cloneObject({ ...filterValues[id], value, error: '', draftFlow });

        setFilterValues({
            ...filterValues,
            [id]: field,
        });
    }

    function handleChangeRange(date, _, { range }) {
        if (!date) {
            setRangeLimits({
                min: '',
                max: '',
            });

            return;
        }

        const cloneDate = cloneObject(date);

        if (range === 'start') {
            setRangeLimits({
                ...rangeLimits,
                min: moment(cloneDate[0]),
            });
        }

        if (range === 'end') {
            setRangeLimits({
                ...rangeLimits,
                max: moment(cloneDate[1]),
            });
        }
    }

    async function loadData() {
        const payloadConsultaFuturas = {
            cabecalho: {
                canal: 'M',
                codigoEmpresaOrigem: '1',
                divisaoNegocio: '1',
                empresaOrigemAtendimento: '1',
                origemContrato: '1',
                tipoContrato: '1',
                token: '1',
                unidadeNegocio: '1',
            },
            carteirinha: dataConsultaAtendimento.beneficiarioEventual.numCarteira,
            tipoConvenio: null,
            canalAgendamento: null,
            compareceuConsulta: null,
            quantidadeOcorrencias: 0,
            dataInicio: '',
            dataFim: '',
            dataConsulta: null,
            consultaId: 0,
            consultaSequencia: 0,
        };

        await consultasFulturas(payloadConsultaFuturas).then((el) => {
            if (el) {
                setDataTable(el.dadosConsulta);
                setDataTableDefault(el.dadosConsulta);
            } else {
                setDataTable([]);
                setDataTableDefault([]);
            }
        });
    }

    async function handleConfirmDeleteFile(value) {
        dataTable.every(async (item) => {
            if (item.idConsulta === value) {
                setPageLoading(true);
                const payload = {
                    cabecalho: {
                        canal: 'M',
                        codigoEmpresaOrigem: '1',
                        divisaoNegocio: '1',
                        empresaOrigemAtendimento: '1',
                        origemContrato: '1',
                        tipoContrato: '1',
                        token: '1',
                        unidadeNegocio: '1',
                    },
                    carteirinha: dataConsultaAtendimento.beneficiarioEventual.numCarteira,
                    dataNascimento: '',
                    idConsulta: item.idConsulta,
                    protocoloAgendamento: '',
                    sequenceConsulta: item.sequenciaConsulta,
                    tipoConvenio: '',
                };

                await cancelarAgendamento(payload);
                setSucessDelete(true);
                setPageLoading(false);
            }
            loadData();
        });

        setShowModalDeleteFile(false);
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <PageContainer>
                <Accordion title="Próximas consultas" hasCollapse={false}>
                    <FormContainer>
                        <DatepickerRange
                            field={filterValues.rangeDate}
                            onCalendarChange={handleChangeRange}
                            onChange={(event) => handleChangeFilter(event)}
                        />

                        <S.RowButton>
                            <Button loading={pageLoading} onClick={() => handleSearch()}>
                                Filtrar
                            </Button>
                        </S.RowButton>
                    </FormContainer>
                </Accordion>

                {dataTable?.length > 0 ? (
                    dataTable?.map((item) => {
                        const contractSelected = item.idConsulta === selected;

                        return (
                            <S.Container
                                color={contractSelected ? '#F9EDD3' : '#FFFFFF'}
                                id={item.idConsulta}
                                key={item.idConsulta}
                            >
                                <S.DivEndItem>
                                    <div>
                                        <p>{item.data}</p>
                                        <strong>{item.horario}</strong>
                                    </div>
                                </S.DivEndItem>

                                <S.ContainerDataContract>
                                    <p>{item.prestador.nome}</p>

                                    <S.ButtonHospitalArea>
                                        <S.IconPosition>
                                            <Icon
                                                onClick={() => setShowModal(true)}
                                                name="info"
                                                color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                                            />
                                        </S.IconPosition>

                                        <strong
                                            onClick={() => {
                                                setShowModal(true);
                                                handleSelect(item.idConsulta);
                                            }}
                                        >
                                            Informação
                                        </strong>
                                    </S.ButtonHospitalArea>
                                </S.ContainerDataContract>
                                <S.NameEpecialidadeMedico>
                                    <p>Especialidade</p>
                                    <p>{item.especialidade.descricao}</p>
                                </S.NameEpecialidadeMedico>
                                <S.NameEpecialidadeMedico>
                                    <p>Medico</p>
                                    <p>{item.medico.nome}</p>
                                </S.NameEpecialidadeMedico>
                                <S.IconPositionLixeira onClick={() => setShowModalDeleteFile(true)}>
                                    <Icon name="delete" size={24} color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                                </S.IconPositionLixeira>

                                <Modal
                                    title="Centro Clínico Mogi das Cruzes"
                                    visible={showModal}
                                    onCancel={() => setShowModal(false)}
                                    footer={null}
                                >
                                    <S.styledDivModal>
                                        <span>Endereço</span>
                                        <p>
                                            {' '}
                                            {item.prestador.endereco[0].logradouro} -{' '}
                                            {item.prestador.endereco[0].numero} - {item.prestador.endereco[0].bairro} -{' '}
                                            {item.prestador.endereco[0].cidade} - {item.prestador.endereco[0].estado}
                                        </p>
                                    </S.styledDivModal>
                                </Modal>
                                <Modal
                                    title="Cancelar solicitação"
                                    subtitle="Ao clicar você vai cancelar definitivamente seu horário."
                                    visible={showModalDeleteFile}
                                    onCancel={() => setShowModalDeleteFile(false)}
                                    footer={null}
                                >
                                    <Button
                                        type="secondary"
                                        onClick={() => {
                                            setShowModalDeleteFile(false);
                                        }}
                                    >
                                        Não
                                    </Button>
                                    <Button type="primary" onClick={() => handleConfirmDeleteFile(item.idConsulta)}>
                                        Sim
                                    </Button>
                                </Modal>
                            </S.Container>
                        );
                    })
                ) : (
                    <div>
                        <Alert type="2" title={emptyMessage} />
                    </div>
                )}
                <Modal
                    title="Atenção"
                    subtitle={modalMessage}
                    visible={sucessDelete}
                    onCancel={() => setSucessDelete(false)}
                    footer={null}
                >
                    <Button
                        type="primary"
                        onClick={() => {
                            setSucessDelete(false);
                        }}
                    >
                        Ok
                    </Button>
                </Modal>
                <ContainerButton>
                    <Button id="backStep" type="primary" onClick={() => history.goBack()}>
                        Voltar
                    </Button>
                </ContainerButton>
            </PageContainer>
            <PageLoader loading={pageLoading} />
        </>
    );
}

export default ListaConsulta;
